import { Route } from 'react-router-dom';
import BasicInfoContainer from '../containers/BasicInfoContainer';
import UserPreferences from '../containers/UserPreferences';
import { jsx as _jsx } from "react/jsx-runtime";
const RouteConfig = () => {
  return /*#__PURE__*/_jsx(Route, {
    path: "/",
    children: /*#__PURE__*/_jsx(UserPreferences, {
      children: /*#__PURE__*/_jsx(BasicInfoContainer, {})
    })
  });
};
export default RouteConfig;